var _defs, _ellipse, _path, _path2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack370({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}.c{stroke-linecap:square;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 7.98,
    cy: 8,
    rx: 6.98,
    ry: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.21,11.07V4.93h1l1.2,4.35.24.91c.06-.23.14-.56.26-1L7.12,4.93H8v6.14H7.38V5.93L5.91,11.07h-.6L3.85,5.84v5.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.08,11.07V4.93h1.74a3.1,3.1,0,0,1,1,.11,1.7,1.7,0,0,1,.77.54,2.82,2.82,0,0,1,.5,1A4.88,4.88,0,0,1,13.25,8a4.49,4.49,0,0,1-.31,1.77,2.14,2.14,0,0,1-.78,1,2.35,2.35,0,0,1-1.26.3Zm.67-.72h1.07a1.92,1.92,0,0,0,1-.21,1.35,1.35,0,0,0,.51-.68A4.21,4.21,0,0,0,12.56,8a3.47,3.47,0,0,0-.25-1.47,1.41,1.41,0,0,0-.65-.72,2.28,2.28,0,0,0-.86-.12H9.75Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 1,
    y1: 1,
    x2: 1,
    y2: 15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 15,
    y1: 15,
    x2: 1,
    y2: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack370);
export default __webpack_public_path__ + "static/media/Symbol_pack_370.e78e9c01a4e7af4b5fb5f53dd21bc07a.svg";
export { ForwardRef as ReactComponent };